<template>
  <div class="account">
    <div class="horizontal-gradient border-style">
      <div style="width: 100%; height: 40px" class="border-style"></div>
      <van-image
        round
        width="5rem"
        height="5rem"
        :src="require('.././assets/231.jpg')"
      />
      <div style="width: 100%; height: 60px; color: #fff" class="border-style">
        <div><van-icon name="fire" color="#fff" />{{ userInfo.username }}</div>
        <div>ID:{{ userInfo.userId }}</div>
        <div class="nav-bottom" style="background: #9d8040">
          <div style="margin-right: 10px">
            <van-icon
              style="color: linear-gradient(45deg, #ffa 0%, #ee7 100%)"
              name="diamond-o"
            />
            <span v-if="userInfo.grade" style="color: #ffd700">
              {{ userInfo.grade }}</span
            >
            <span v-else style="color: #d3d3d3">VIP</span>
          </div>
          <div style="width: 100px">
            <van-progress
              :pivot-text="userInfo.diff"
              :show-pivot="userInfo.showDiff"
              :percentage="99"
            />
          </div>
          <div style="margin-left: 10px">{{ userInfo.nextGrade }}</div>
        </div>
      </div>
    </div>

    <div class="content-section">
      <van-row>
        <!-- <van-col span="8">
          <div style="height: 60px; line-height: 25px">
            <div style="font-size: 12px">{{ $t("account.profit") }}</div>
            <div>0.00</div>
          </div>
        </van-col>
        <van-col span="8">
          <div style="height: 60px; line-height: 25px">
            <div style="font-size: 12px">{{ $t("account.win") }}</div>
            <div>0.00</div>
          </div>
        </van-col>
        <van-col span="8">
          <div style="height: 60px; line-height: 25px">
            <div style="font-size: 12px">{{ $t("account.balance") }}</div>
            <div>{{ userInfo.money }}</div>
          </div>
        </van-col> -->
        <van-col span="12">
          <div style="height: 60px; line-height: 60px">
            <div>{{ $t("account.balance") }}</div>
          </div>
        </van-col>
        <van-col span="12">
          <div style="height: 60px; line-height: 60px">
            <div>${{ userInfo.showMoney }}</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="content-section">
      <van-grid :border="false" direction="horizontal" :column-num="2">
        <van-grid-item @click="navTo('/recharge')">
          <template #icon>
            <van-icon
              size="25px"
              style="margin-right: 10px"
              name="after-sale"
            />
          </template>
          <template #text>
            <div>{{ $t("account.recharge") }}</div>
          </template>
        </van-grid-item>
        <van-grid-item @click="navTo('/withdraw')">
          <template #icon>
            <van-icon
              size="25px"
              style="margin-right: 10px"
              name="cash-back-record-o"
            />
          </template>
          <template #text>
            <div>{{ $t("account.withdraw") }}</div>
          </template>
        </van-grid-item>
      </van-grid>
    </div>

    <div class="content-section">
      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="navTo('/wallet')"
      >
        <template #icon>
          <van-icon size="25px" name="pending-payment" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("account.wallet") }}
          </div>
        </template>
      </van-cell>

      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="navTo('/creditHome/'+userInfo.userId)"
      >
        <template #icon>
          <van-icon size="25px" name="award-o" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("account.notice") }}
          </div>
          <!-- <a href="https://info.grandlisboavip.top" target="_blank" style="color: #323233;">
            <div style="margin-left: 10px; width: 200px; font-size: 18px">
              {{ $t("account.notice") }}
            </div>
          </a> -->
        </template>
      </van-cell>

      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="navTo('/fundsflow')"
      >
        <template #icon>
          <van-icon size="25px" name="todo-list-o" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("account.funds") }}
          </div>
        </template>
      </van-cell>

      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="navTo('/pass')"
      >
        <template #icon>
          <van-icon size="25px" name="sign" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("account.pass") }}
          </div>
        </template>
      </van-cell>

      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="navTo('/fundsPassword')"
      >
        <template #icon>
          <van-icon size="25px" name="certificate" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("account.password") }}
          </div>
        </template>
      </van-cell>

      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="navTo('/language/2')"
      >
        <template #icon>
          <van-icon size="25px" name="pending-payment" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("nav.language") }}
          </div>
        </template>
      </van-cell>

      <van-cell
        icon="pending-payment"
        center
        title-style="text-align: left"
        is-link
        value=""
        @click="logout"
      >
        <template #icon>
          <van-icon size="25px" name="revoke" />
        </template>
        <template #title>
          <div style="margin-left: 10px; width: 200px; font-size: 18px">
            {{ $t("account.exit") }}
          </div>
        </template>
      </van-cell>
    </div>

    <div>
      <van-tabbar
        safe-area-inset-bottom
        placeholder
        v-model="active"
        @change="onChange"
      >
        <van-tabbar-item to="/" icon="home-o" name="0">{{
          $t("tabbar.home")
        }}</van-tabbar-item>
        <van-tabbar-item to="/recharge" icon="cash-o" name="1">{{
          $t("tabbar.recharge")
        }}</van-tabbar-item>
        <van-tabbar-item :url="config.telegraph" icon="service-o" name="2">{{
          $t("tabbar.contact")
        }}</van-tabbar-item>
        <van-tabbar-item to="/account" icon="manager-o" name="3">{{
          $t("tabbar.account")
        }}</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { logout } from "@/common/api/api";

export default {
  name: "Account",
  components: {},
  data() {
    return {
      url: "",
      active: 3,
      userInfo: {
        userId: "",
        username: "",
        money: 0.0,
        grade: "",
      },
      config: {},
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.config = this.$store.getters.config;
  },
  methods: {
    navTo(path) {
      this.$router.push(path);
    },
    onChange(val) {
      this.active = val;
    },
    logout() {
      this.$store.dispatch("logout").then((res) => {
        this.navTo("/login");
      });
    },
  },
};
</script>

<style lang="scss">
.account {
  .horizontal-gradient {
    /* background: linear-gradient(to right, blue, pink); */
    /* background: linear-gradient(to right, 	rgb(255, 215, 0), 	rgb(255, 215, 0)); */
    background: #9d8040;
  }
}

.border-style {
  border::after {
    border: none;
  }
}

.nav-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-top: 16px;
}

.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin: 0 10px 10px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.vertical-divider {
  width: 1px;
  border-left: 1px solid #000000;
  height: 100%;
  margin: 0 10px;
}
</style>
